import { categoryConst } from "../constants/categoryConst";
import { categoryService } from "../../services/API/categoryService";
import auth from "../../services/auth";

export const categoriesActions = {
  addCategory
};

function addCategory(category) {
  return dispatch => {
    dispatch(request({ category }));
    categoryService.addCategory(category).then(
      category => {
        dispatch(success(user));
      },
      error => {
        dispatch(failure(error.toString()));
        alert("Error coming...,", error.toString());
      }
    );
  };

  function request(category) {
    return { type: categoryConst.ADD_CATEGORY, category };
  }
  function success(category) {
    return { type: categoryConst.ADD_CATEGORY_SUCCESS, category };
  }
  function failure(error) {
    return { type: categoryConst.ADD_CATEGORY_FAILURE, error };
  }
}



// WEBPACK FOOTER //
// ./src/app/redux/actions/categories.js